/// <amd-module name="Artifacts/Feed/components/NoPackages" />
import * as Res from "Artifacts/Feed/Resources";
import { DefaultLoader } from "Artifacts/Root/components/DefaultLoader";
import { FWLink } from "Artifacts/Root/components/FWLink";
import { useFeed } from "Artifacts/Root/hooks/FeedUrlResolver";
import * as RootRes from "Artifacts/Root/Resources";
import { connectToFeed } from "Artifacts/Root/routing/Constants";
import * as React from "react";
import { generatePath, useHistory } from "react-router-dom";
import { useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Button } from "VSSUI/Button";
import { ZeroData } from "VSSUI/ZeroData";

export interface INoPackagesProps {
  showSearchUpstreamsModal: () => void;
}

const NoPackages: React.FC<INoPackagesProps> = ({ showSearchUpstreamsModal }) => {
  const history = useHistory();
  const { pageContext } = useComponentContext();
  const { feed, resolution } = useFeed();

  return (
    <DefaultLoader state={resolution}>
      <ZeroData
        primaryText={Res.NoPackages_Description}
        secondaryText={
          <div className="no-packages-secondary">
            <div>
              <Button
                primary={true}
                onClick={() => {
                  history.push(generatePath(connectToFeed, { feedIdentifier: feed?.name }));
                }}
              >
                {RootRes.ConnectToFeedButton}
              </Button>
            </div>
            <div>
              <div className="vss-ZeroDataItem--primary title-m">
                {Res.NoPackages_SearchUpstream}
              </div>
              <div>
                <Button primary={true} onClick={showSearchUpstreamsModal}>
                  {RootRes.ShowSearchUpstreamsPanelButtonText}
                </Button>
              </div>
            </div>
            <div>
              <FWLink linkId="699424">{Res.NoPackages_LearnMoreLink}</FWLink>
            </div>
          </div>
        }
        imageAltText={""}
        imagePath={getAssetLocation(
          pageContext,
          "ms.azure-artifacts/feed/img/zerodata-connect-to-feed.svg",
        )}
      />
    </DefaultLoader>
  );
};

const NoPackagesFiltered: React.FC<INoPackagesProps> = ({ showSearchUpstreamsModal }) => {
  const { pageContext } = useComponentContext();

  return (
    <ZeroData
      primaryText={Res.NoPackagesFiltered_Description}
      secondaryText={
        <div className="no-packages-secondary">
          <div>
            <Button primary={true} onClick={showSearchUpstreamsModal}>
              {RootRes.ShowSearchUpstreamsPanelButtonText}
            </Button>
          </div>
        </div>
      }
      imageAltText={""}
      imagePath={getAssetLocation(pageContext, "ms.azure-artifacts/feed/img/search.svg")}
    />
  );
};

export { NoPackages, NoPackagesFiltered };
